import React from 'react';
import { Tabs as ATabs } from 'antd';
import styled from 'styled-components';

import 'antd/lib/tabs/style/index.css';

const StyledTabs = styled(ATabs)`
  .ant-tabs-nav {
    border-bottom: none;
    margin: 0;
  }

  .ant-tabs-tab-btn {
    padding: 12px 31px;
  }

  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: var(--ultramarine-blue);
    border: none;
    border-bottom: 4px solid var(--ultramarine-blue);
    font-family: 'Circular-Bold', 'Circular', sans-serif; /* TODO: should expose this as API */
    text-shadow: none;
    border-radius: 4px;
  }

  &.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab,
  .ant-tabs-card > div > .ant-tabs-nav .ant-tabs-tab {
    border: none;
    padding: 0px;
    margin-left: 8px;
  }

  &:hover .ant-tabs-tab-btn {
    color: var(--bluey-grey);
  }
`;

class TabTitle extends React.Component {
  render() {
    const { hasNotifications, children } = this.props;
    return (
      <span>
        {children}
        {hasNotifications ? <span className="red-dot" /> : null}
      </span>
    );
  }
}

class TabPane extends React.Component {
  render() {
    return <StyledTabs.TabPane {...this.props} />;
  }
}

class Tabs extends React.Component {
  static TabTitle = TabTitle;
  static TabPane = TabPane;

  render() {
    return <StyledTabs type="card" {...this.props} />;
  }
}

export default Tabs;
